'use client';

import { datadogLogs } from '@datadog/browser-logs';

export function clearLogIdentity(): void {
  datadogLogs.clearUser();
}

export function setLogIdentity(userId: string | undefined): void {
  if (!userId) {
    clearLogIdentity();

    return;
  }

  datadogLogs.setUser({ id: userId });
}
